<template>
  <div class="page-header">
    <div class="header-title">
      <slot name="title" />
    </div>
    <div class="header-center" v-if="tabsArray.length > 0">
      <template v-for="item in tabsArray">
        <div
          class="header-center-box"
          @click="handleClick(item.value)"
          :class="item.value === activeTab ? 'is-active' : ''"
        >
          {{ item.label }}
        </div>
      </template>
    </div>
    <div class="header-right">
      <slot name="right-panel" />
      <span class="icon" @click="setFullscreen">
        <i
          class="iconfont"
          :class="[fullscreen ? 'icon-cancelFullScreen' : 'icon-fullScreen']"
        />
      </span>
      <div class="line" />
      <span class="icon" style="margin-right: 20px">
        <i class="iconfont icon-noticeLine" />
      </span>
      <span class="icon" style="margin-right: 20px">
        <i class="iconfont icon-help" />
      </span>
      <div class="avatar-icon" />
      <avatar ref="avatar" :password-modify-visible="passwordModifyVisible" />
    </div>
  </div>
</template>

<script>
import Avatar from "./Avatar.vue";

export default {
  name: "PageHeader",
  components: { Avatar },
  props: {
    tabs: {
      type: Array,
      default() {
        return [];
      }
    },
    passwordModifyVisible: { type: Boolean, default: true }
  },
  data() {
    return {
      tabsArray: this.tabs,
      menuNotice: null,
      horizontalMenuActiveTab: null,
      fullscreen: false,
      activeTab: 1
    };
  },
  watch: {},
  mounted() {
    // 禁用F11
    document.addEventListener("keydown", event => {
      var e = event || window.event;
      if (e.key === "F11") {
        e.preventDefault();
      }
    });
    window.addEventListener("resize", () => {
      this.fullscreen = !this.fullscreen;
    });
  },
  methods: {
    handleClick(value) {
      this.activeTab = value;
      this.$emit("tabChange", value);
    },
    setFullscreen() {
      if (this.fullscreen) {
        this.exitFullscreen();
      } else {
        this.enterFullscreen();
      }
    },
    // 进入全屏模式
    enterFullscreen() {
      var elem = document.documentElement; // 获取文档的根元素
      if (elem.requestFullscreen) {
        elem.requestFullscreen(); // 标准方法
      } else if (elem.mozRequestFullScreen) {
        /* Firefox */
        elem.mozRequestFullScreen();
      } else if (elem.webkitRequestFullscreen) {
        /* Chrome, Safari & Opera */
        elem.webkitRequestFullscreen();
      } else if (elem.msRequestFullscreen) {
        /* IE/Edge */
        elem.msRequestFullscreen();
      }
    },
    // 退出全屏模式
    exitFullscreen() {
      if (document.exitFullscreen) {
        document.exitFullscreen(); // 标准方法
      } else if (document.mozCancelFullScreen) {
        /* Firefox */
        document.mozCancelFullScreen();
      } else if (document.webkitExitFullscreen) {
        /* Chrome, Safari and Opera */
        document.webkitExitFullscreen();
      } else if (document.msExitFullscreen) {
        /* IE/Edge */
        document.msExitFullscreen();
      }
    },
    onFullScreenChange() {
      if (
        !!document.fullscreenElement ||
        document.mozFullScreen ||
        document.webkitIsFullScreen ||
        document.msFullscreenElement
      ) {
        console.log("Exited full screen");
      } else {
        console.log("Entered full screen");
      }
    }
  }
};
</script>
<style lang="less" scoped>
.icon {
  line-height: 1;
}

.iconfont {
  font-size: 18px;
  color: #fff;
  cursor: pointer;
}

.line {
  width: 1px;
  height: 18px;
  margin: 0 15px;
  background-color: #fff;
}
</style>
